export { default } from './EntryRequirement';
export type { Props } from './EntryRequirement';
